<template>
  <v-list>
    <v-list-item
      v-for="store in getStoresForCurrentOrganisation"
      :key="store.id"
    >
      <v-autocomplete
        :label="store.name_store"
        :items="getSuppliers"
        item-text="name_fournisseur"
        item-value="id_fournisseur"
        clearable
        :value="
          suppliers.find(x => x.store === store.id_store)
            ? suppliers.find(x => x.store === store.id_store).supplier
            : null
        "
        @change="v => changeSupplier(v, store)"
        autocomplete="off"
      >
        <template v-slot:append-outer>
          <v-row align="center" justify="end" no-gutters>
            <v-btn icon small color="primary" @click="addSupplier">
              <v-icon small>fa-plus</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-autocomplete>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/api";
export default {
  name: "RecipeProductSupplierInput",
  props: {
    id: {
      required: true
    },
    suppliers: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getStoresAvailables", "getOrganisationId", "getSuppliers"]),
    getStoresForCurrentOrganisation() {
      return this.getStoresAvailables.filter(
        x => x.organisation === this.getOrganisationId
      );
    }
  },
  methods: {
    changeSupplier(value, store) {
      const loc = this.suppliers.find(x => x.store === store.id_store);
      if (loc) {
        api.putRecipeProductSupplier(loc.id, {
          id: loc.id,
          fk_product: this.id,
          supplier: value ? value : null,
          store: store.id_store
        });
      } else {
        api.postRecipeProductSupplier({
          fk_product: this.id,
          supplier: value,
          store: store.id_store
        });
      }
    },
    async addSupplier() {
      let res = await this.$dialog.prompt({
        text: "Entrer le nom du nouveau fournisseur",
        title: "Nouveau fournisseur"
      });
      if (res) {
        this.$store.dispatch("addSupplier", {
          organisation: this.getOrganisationId,
          name_fournisseur: res
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
